import { css } from "@emotion/react";

export const containerStyle = css`
  display: flex;
  align-items: start;
  justify-content: start;

  height: 71px;
  margin-right: 27px;
  margin-left: 24px;
  margin-top: 48px;

  @media only screen and (max-width: 992px) {
    margin-top: 24px;
  }
`;

export const collapsedContainerStyle = css`
  display: flex;
  align-items: start;
  justify-content: center;

  height: 71px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 48px;

  @media only screen and (max-width: 992px) {
    margin-top: 24px;
  }
`;

export const profileStyle = css`
  margin-left: 12px;
`;

export const avaNameStyle = css`
  color: #ffffff;
`;
